module.exports = __webpack_public_path__ + "img/39_004_010_.db96120f.png";